import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';
import debounce from 'lodash/debounce';
export const icdMixins = {
    data() {
        return {
            icd: [],
            params: {
                query: {
                    $limit: 100,
                    $sort: {
                        code: 1
                    }
                }
            },
        }
    },
    computed: {
        ...mapState('icd', {
            icdLoading: 'isFindPending'
        }),
        ...mapGetters('icd', {
            findIcdInStore: 'find',
            getIcd: 'get'
        }),
        ...mapGetters('specialty', {
            findSpecialtyInStore: 'find',
        }),

        specialties() {
            return this.findSpecialtyInStore().data;
        },
        // icd1() {
        //     // delete this.params.query.specialty;
        //     return this.findIcdInStore(this.params).data;
        // },
    },
    watch: {
        query: debounce(function (newVal) {
            this.queryItems();
        }, 400),
        parentId: debounce(function (newVal) {
            this.queryItems();

        }, 400),
        specialtyQuery: debounce(function (newVal) {

            if (newVal.length > 0) {
                this.params.query.specialty = newVal;
            } else {
                delete this.params.query.specialty;
            }
            this.queryItems();
        }, 400),
    },
    created() {
        this.fetchSpecialties();
    },
    methods: {
        ...mapActions('icd', ['find', 'get']),
        ...mapActions('specialty', {
            fetchSpecialties: 'find'
        }),


        queryItems() {
            if (this.query) {
                this.params.query.$or = [{
                        label: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        code: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                    {
                        description: {
                            $regex: this.query,
                            $options: "i"
                        }
                    },
                ];
            } else {
                delete this.params.query.$or;
            }

            if (this.parentId) {
                this.params.query.parentId = this.parentId;
            } else {
                this.params.query.parentId = null;
                if (this.query) {
                    delete this.params.query.parentId;
                }
            }

            this.find(this.params).then(result => {
                this.breadcrumbs = [];
                this.getParents(this.parentId);
                this.icd = result.data;
            });

        },
    }

}
